module.exports = __webpack_public_path__ + "static/colgadas-013.thumb-f17648970784040a4c58b6c1e2732d16.jpg";